package com.example.mystybag.login.model

import com.example.mystybag.core.model.CityItem
import com.example.mystybag.core.model.CountryItem

data class MerchantRegistrationAddCompanyDetailsUIState(
    val bulstat: String = "",
    val bulstatError: String? = null, // Error message for BULSTAT validation
    val privacyPolicyAccepted: Boolean = false,
    /** Shown after Next when terms were not accepted (red hint under checkbox). */
    val privacyPolicyError: Boolean = false,
    val isLoading: Boolean = false
)
